(function () {
    'use strict';

    angular
        .module('app')
        .factory('systemOptionsService', systemOptionsService);

    systemOptionsService.$inject = ['$http', '$q', '$localStorage'];

    function systemOptionsService($http, $q, $localStorage) {
        var localStorage = $localStorage;

        var service = {
            getAllowDownload: getAllowDownload,
            setAllowDownload: setAllowDownload,
            getEnableUpload: getEnableUpload,
            getLocalViewerSettings: getLocalViewerSettings,
            setClearVLAtStartup: setClearVLAtStartup,
            getClearVLAtStartup: getClearVLAtStartup,
            clearVirtualLibrary: clearVirtualLibrary,
            getShowExtraCommands: getShowExtraCommands,
            getStartUpOptions: getStartUpOptions,
            processing: false,
            startUpOptions: {},
        };

        return service;

        function getEnableUpload() {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/AdminOptions/EnableUpload/').then(function (response) {
                service.enableUpload = response.data;
                service.processing = false;
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        // Gets all of the local viewer settings
        function getLocalViewerSettings() {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/AdminOptions/LocalViewerSettings/').then(function (response) {
                //vm.viewWith = data.ViewerType;
                //vm.showViewRenderPdfMenu = data.ShowViewRenderPdfMenu;
                service.showViewRenderPdfMenu = response.data.ShowViewRenderPdfMenu;
                // If ViewerType==0 (AutoVue Only), hide the Local Viewer Option entirely.
                if (response.data.ViewerType == 0) {
                    service.showLocalViewerMenu = false;
                } else {
                    service.showLocalViewerMenu = true;
                }
                service.processing = false;
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function getStartUpOptions() {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/AdminOptions/StartupOptions/').then(function (response) {
                service.startUpOptions = response.data;

                //convert string values to bool when applicable
                for (var key in service.startUpOptions) {
                    if (typeof service.startUpOptions[key] === 'string') {
                      if (service.startUpOptions[key] === 'true') {
                        service.startUpOptions[key] = true;
                      } else if (service.startUpOptions[key] === 'false') {
                        service.startUpOptions[key] = false;
                      }
                    }
                  }

                deferred.resolve(service.startUpOptions);
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function getAllowDownload() {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/AdminOptions/AllowDownload/').then(function (response) {
                service.allowDownload = response.data;
                service.processing = false;
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function setAllowDownload(bAllow) {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/AdminOptions/AllowDownload/' + bAllow).then(function (response) {
                service.allowDownload = bAllow;
                service.processing = false;
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function getClearVLAtStartup() {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/AdminOptions/ClearVLAtStartup/').then(function (response) {
                service.processing = false;
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function setClearVLAtStartup(clearVLAtStartup) {
           var request = $http({
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("Content-Type", "application/json");
                },
                method: 'PUT',
                dataType: 'json',
                contentType: 'application/json',
                crossDomain: true,
                cache: false,
                url: '../Synergis.WebApi/api/AdminOptions/ClearVLAtStartup',
                data: JSON.stringify(clearVLAtStartup)
            }, function (err, status) {
                console.info('setClearVLAtStartup error', err, status);
            });
            return request;
        }

        function clearVirtualLibrary() {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/AdminOptions/ClearVirtualLibrary/').then(function (response) {
                service.processing = false;
                deferred.resolve(response.data);
            }, function () {
                service.processing = false;
                deferred.resolve(false);
            });
            return deferred.promise;
        }

        function getShowExtraCommands() {
            service.processing = true;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/AdminOptions/ShowExtraCommands/').then(function (response) {
                service.showExtraCommands = response.data;
                service.processing = false;
                deferred.resolve(response.data);
            }, function () {
                service.processing = false;
                deferred.resolve(false);
            });
            return deferred.promise;
        }

        Object.defineProperty(service, "allowDownload", {
            get: function () {
                var allowDownload = $localStorage.userInfo.allowDownload;
                if (allowDownload === "" || allowDownload === undefined) {
                    allowDownload = $cookies.get('allowDownload');
                }
                return allowDownload;
            },
            set: function (allowDownload) {
                $localStorage.userInfo.allowDownload = allowDownload;
                $cookies.put('allowDownload', allowDownload);
            }
        });

        Object.defineProperty(service, "enableUpload", {
            get: function () {
                var enableUpload = $localStorage.userInfo.enableUpload;
                if (enableUpload === "" || enableUpload === undefined) {
                    enableUpload = $cookies.get('enableUpload');
                }
                return enableUpload;
            },
            set: function (enableUpload) {
                $localStorage.userInfo.enableUpload = enableUpload;
                $cookies.put('enableUpload', enableUpload);
            }
        });

        Object.defineProperty(service, "showViewRenderPdfMenu", {
            get: function () {
                var showViewRenderPdfMenu = $localStorage.userInfo.showViewRenderPdfMenu;
                if (showViewRenderPdfMenu === "" || showViewRenderPdfMenu === undefined) {
                    showViewRenderPdfMenu = $cookies.get('showViewRenderPdfMenu');
                }
                return showViewRenderPdfMenu;
            },
            set: function (showViewRenderPdfMenu) {
                $localStorage.userInfo.showViewRenderPdfMenu = showViewRenderPdfMenu;
                $cookies.put('showViewRenderPdfMenu', showViewRenderPdfMenu);
            }
        });

        Object.defineProperty(service, "showLocalViewerMenu", {
            get: function () {
                var showLocalViewerMenu = $localStorage.userInfo.showLocalViewerMenu;
                if (showLocalViewerMenu === "" || showLocalViewerMenu === undefined) {
                    showLocalViewerMenu = $cookies.get('showLocalViewerMenu');
                }
                return showLocalViewerMenu;
            },
            set: function (showLocalViewerMenu) {
                $localStorage.userInfo.showLocalViewerMenu = showLocalViewerMenu;
                $cookies.put('showLocalViewerMenu', showLocalViewerMenu);
            }
        });
    }
})();